<mat-card class="example-card">
    <img src="/api/attachables/{{id}}/download_attachment?token={{token}}" alt="">
    <mat-card-actions>
        <button mat-button (click)="delete(id)" color="warn">Delete</button>
    </mat-card-actions>
</mat-card>